export class PropertyControlOptions {
    constructor(
        public variantRequired = false,
        public ignoreIndex = false,
        public arrayIndexRequired = true,
        public fieldRequired = true,
        public ignoreVariant = false
    ) {}
}
